import React, { useState } from 'react';
import { Button } from '@mui/material';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';

const Logout = ({ navigateTo = '/login' }) => {
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();
  const logout = () => {
    setDisabled(true);
    signOut(auth)
      .then(() => {
        navigate(navigateTo);
      })
      .catch((error) => {
        setDisabled(false);
      });
  };

  return (
    <Button
      disabled={disabled}
      onClick={logout}
      color={'inherit'}
    >
      Logout
    </Button>
  );
};

export default Logout;
